/** biome-ignore-all lint/correctness/noUnusedImports: reason */
/** biome-ignore-all lint/a11y/noStaticElementInteractions: reason */
/** biome-ignore-all lint/a11y/useValidAnchor: reason */
/** biome-ignore-all lint/a11y/useAriaPropsSupportedByRole: reason */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Component } from 'react';
import { getObjFromLink } from '../../../context/helpers';
import {
	FaAddressBook,
	FaBeer,
	FaBell,
	FaBuilding,
	FaChevronDown,
	FaClipboard,
	FaClipboardCheck,
	FaClipboardList,
	FaCubes,
	FaDatabase,
	FaDollyFlatbed,
	FaHistory,
	FaInbox,
	FaLifeRing,
	FaMapMarkedAlt,
	FaMapMarkerAlt,
	FaPencilAlt,
	FaSearch,
	FaSyncAlt,
	FaTachometerAlt,
	FaTags,
	FaTint,
	FaTruck,
	FaUsers,
	FaEdit
} from '../../ui/icons';

import NavigationItem from './NavigationItem/NavigationItem';

import './NavigationItems.css';

const subMenuClickHandler = (e) => {
	e.preventDefault();
	const expanded = e.target.getAttribute('aria-expanded') === 'true' || false;
	e.target.setAttribute('aria-expanded', !expanded);
};

class NavigationItems extends Component {
	render() {
		const { visible, toggle, claims, profile } = this.props;
		let compId = 'not-set';

		if (claims?.companyLink) {
			compId = getObjFromLink(claims.companyLink).id;
		}

		const classes = ['main-nav'];

		if (visible) {
			classes.push('open');
		} else classes.push('closed');

		return (
			<nav className={classes.join(' ')}>
				{process.env.REACT_APP_ENV !== 'production' && (
					<div className="staging-label">{process.env.REACT_APP_ENV}</div>
				)}

				<ul className="navigation-items">
					<NavigationItem link="/dashboard" exact toggle={toggle}>
						<FaTachometerAlt />
						Dashboard
					</NavigationItem>

					<li className="navigation-item">
						<a onClick={subMenuClickHandler} aria-expanded="false">
							<FaDatabase /> Kegs <FaChevronDown className="arrow" />
						</a>

						<ul className="sub-menu">
							<NavigationItem link="/kegs-list" toggle={toggle}>
								<FaClipboardList />
								List of Kegs
							</NavigationItem>

							<NavigationItem link="/map" toggle={toggle}>
								<FaMapMarkedAlt />
								Map
							</NavigationItem>

							<NavigationItem link="/keg-batch-update" toggle={toggle}>
								<FaClipboardCheck />
								Bulk Update Kegs
							</NavigationItem>

							<NavigationItem link="/keg-quick-view" toggle={toggle}>
								<FaSearch />
								QuickView
							</NavigationItem>

							<NavigationItem link="/inspection-pile" toggle={toggle}>
								<FaDollyFlatbed />
								Inspection Pile
							</NavigationItem>

							<NavigationItem link="/onboard-kegs" toggle={toggle}>
								<FaCubes />
								Onboard Kegs
							</NavigationItem>
						</ul>
					</li>

					<li className="navigation-item">
						<a onClick={subMenuClickHandler} aria-expanded="false">
							<FaTint /> BREWING <FaChevronDown className="arrow" />
						</a>

						<ul className="sub-menu">
							<NavigationItem link="/keg-fill" toggle={toggle}>
								<FaTint />
								Fill Kegs
							</NavigationItem>

							{claims && compId !== 'not-set' && (
								<NavigationItem link={`/companies/batches`} toggle={toggle}>
									<FaClipboardList />
									Manage Batches
								</NavigationItem>
							)}
						</ul>
					</li>

					<li className="navigation-item">
						<a onClick={subMenuClickHandler} aria-expanded="false">
							<FaHistory /> Stock Management <FaChevronDown className="arrow" />
						</a>

						<ul className="sub-menu">
							<NavigationItem link="/dispatch" toggle={toggle}>
								<FaTruck />
								Dispatch Kegs
							</NavigationItem>

							<NavigationItem link="/receive" toggle={toggle}>
								<FaInbox />
								Receive Kegs
							</NavigationItem>

							<NavigationItem link="/warehouse-transfer" toggle={toggle}>
								<FaMapMarkerAlt />
								Warehouse Transfer
							</NavigationItem>
						</ul>
					</li>

					<NavigationItem link="/reports/dash" toggle={toggle}>
						<FaClipboard />
						Reports
					</NavigationItem>

					{profile?.role !== 'warehouse' && compId !== 'not-set' && (
						<li className="navigation-item">
							<a onClick={subMenuClickHandler} aria-expanded="false">
								<FaBuilding /> Brewery Settings{' '}
								<FaChevronDown className="arrow" />
							</a>

							<ul className="sub-menu">
								<div>
									<NavigationItem link={`/companies/users`} toggle={toggle}>
										<FaUsers />
										Manage Users
									</NavigationItem>

									<NavigationItem link={`/companies/details`} toggle={toggle}>
										<FaPencilAlt />
										Edit Information
									</NavigationItem>

									<NavigationItem link={`/companies/clients`} toggle={toggle}>
										<FaAddressBook />
										Manage Clients
									</NavigationItem>

									<NavigationItem link={`/companies/locations`} toggle={toggle}>
										<FaEdit />
										Manage Warehouses
									</NavigationItem>

									<NavigationItem link={`/companies/partners`} toggle={toggle}>
										<FaUsers />
										Manage Partners
									</NavigationItem>

									<NavigationItem link={`/companies/brands`} toggle={toggle}>
										<FaBeer />
										Manage Brands
									</NavigationItem>

									<NavigationItem link={`/companies/batches`} toggle={toggle}>
										<FaTags />
										Manage Batches
									</NavigationItem>

									<NavigationItem
										link={`/companies/integrations`}
										toggle={toggle}
									>
										<FaSyncAlt />
										Manage Integrations
									</NavigationItem>

									<NavigationItem
										link={`/companies/notifications`}
										toggle={toggle}
									>
										<FaBell />
										Manage Notifications
									</NavigationItem>
								</div>
							</ul>
						</li>
					)}

					<NavigationItem link="/help" toggle={toggle}>
						<FaLifeRing />
						Help
					</NavigationItem>
				</ul>
			</nav>
		);
	}
}

export default NavigationItems;
